import React, { useState } from 'react';
import { useApp } from '../context/AppContext';
import MobileNavigation from '../components/MobileNavigation';

const MobileAircraft = () => {
  const { aircraft, ownedAircraft, currentUser } = useApp();
  const [selectedAircraft, setSelectedAircraft] = useState(null);

  const displayAircraft = currentUser?.user?.orgRole === 'client' ? ownedAircraft : aircraft;

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'available': return '#28a745';
      case 'maintenance': return '#ffc107';
      case 'out of service': return '#dc3545';
      default: return '#6c757d';
    }
  };

  const getMaintenanceStatus = (plane) => {
    const oilDiff = plane.nextOilChange && plane.currentTach ? plane.nextOilChange - plane.currentTach : null;
    const hundredHourDiff = plane.nextHundredHour && plane.currentTach ? plane.nextHundredHour - plane.currentTach : null;
    
    if (oilDiff !== null && oilDiff < 10) return { text: 'Oil Change Due Soon', color: '#dc3545' };
    if (hundredHourDiff !== null && hundredHourDiff < 10) return { text: '100-Hour Due Soon', color: '#dc3545' };
    if (oilDiff !== null && oilDiff < 15) return { text: 'Oil Change Due', color: '#ffc107' };
    if (hundredHourDiff !== null && hundredHourDiff < 15) return { text: '100-Hour Due', color: '#ffc107' };
    
    return { text: 'Maintenance OK', color: '#28a745' };
  };

  const formatDateMmDdYyyy = (value) => {
    if (!value) return '';
    const source = String(value).trim();
    const datePartMatch = source.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (datePartMatch) {
      return `${datePartMatch[2]}/${datePartMatch[3]}/${datePartMatch[1]}`;
    }

    const date = new Date(source);
    if (Number.isNaN(date.getTime())) {
      return source;
    }

    const pad = (n) => String(n).padStart(2, '0');
    return `${pad(date.getMonth() + 1)}/${pad(date.getDate())}/${date.getFullYear()}`;
  };

  return (
    <div className="mobile-screen" style={{ paddingTop: '72px', minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
      <MobileNavigation />
      
      {/* Header */}
      <div className="mobile-section-header" style={{
        padding: '1rem', 
        backgroundColor: 'white', 
        borderBottom: '1px solid #dee2e6',
        position: 'sticky',
        top: '72px',
        zIndex: 100
      }}>
        <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 'bold', color: '#333' }}>
          Aircraft ({displayAircraft.length})
        </h2>
      </div>

      {/* Aircraft List */}
      <div style={{ padding: '1rem' }}>
        {displayAircraft.length === 0 ? (
          <div style={{
            textAlign: 'center',
            padding: '3rem 1rem',
            color: '#666',
            backgroundColor: 'white',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}>
            <div style={{ fontSize: '48px', marginBottom: '1rem' }}>✈️</div>
            <div style={{ fontSize: '18px', marginBottom: '0.5rem' }}>No aircraft found</div>
          </div>
        ) : (
          displayAircraft.map((plane) => {
            const maintenanceStatus = getMaintenanceStatus(plane);
            return (
              <div
                key={plane.id}
                onClick={() => setSelectedAircraft(selectedAircraft?.id === plane.id ? null : plane)}
                style={{
                  backgroundColor: 'white',
                  borderRadius: '8px',
                  padding: '1rem',
                  marginBottom: '1rem',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  border: '1px solid #dee2e6',
                  cursor: 'pointer'
                }}
              >
                {plane.imageUrl && (
                  <img src={plane.imageUrl} alt={plane.tailNumber || plane.registration || 'Aircraft'} style={{ width: '100%', height: '160px', objectFit: 'cover', borderRadius: '6px', marginBottom: '0.75rem', display: 'block' }} />
                )}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '0.5rem' }}>
                  <div>
                    <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#333', marginBottom: '0.25rem' }}>
                      {plane.tailNumber || plane.registration}
                    </div>
                    <div style={{ fontSize: '14px', color: '#666' }}>
                      {plane.make || plane.manufacturer} {plane.model}
                    </div>
                  </div>
                  <div style={{ 
                    fontSize: '12px', 
                    padding: '4px 8px', 
                    backgroundColor: getStatusColor(plane.status),
                    color: 'white',
                    borderRadius: '12px',
                    fontWeight: 'bold'
                  }}>
                    {plane.status || 'Available'}
                  </div>
                </div>
                
                <div style={{ 
                  fontSize: '12px', 
                  padding: '4px 8px', 
                  backgroundColor: maintenanceStatus.color,
                  color: 'white',
                  borderRadius: '12px',
                  fontWeight: 'bold',
                  display: 'inline-block',
                  marginBottom: '0.5rem'
                }}>
                  {maintenanceStatus.text}
                </div>
                
                {plane.rate && (
                  <div style={{ fontSize: '14px', color: '#666', marginBottom: '0.5rem' }}>
                    💰 ${plane.rate}/hour
                  </div>
                )}
                
                {selectedAircraft?.id === plane.id && (
                  <div style={{ 
                    marginTop: '1rem', 
                    paddingTop: '1rem', 
                    borderTop: '1px solid #dee2e6',
                    fontSize: '14px'
                  }}>
                    {plane.year && (
                      <div style={{ marginBottom: '0.5rem', color: '#666' }}>
                        📅 Year: {plane.year}
                      </div>
                    )}
                    {plane.equipment && (
                      <div style={{ marginBottom: '0.5rem', color: '#666' }}>
                        🛠️ Equipment: {plane.equipment}
                      </div>
                    )}
                    {plane.color && (
                      <div style={{ marginBottom: '0.5rem', color: '#666' }}>
                        🎨 Color: {plane.color}
                      </div>
                    )}
                    {plane.nextOilChange && (
                      <div style={{ marginBottom: '0.5rem', color: '#666' }}>
                        🛢️ Next Oil Change: {plane.nextOilChange} hours
                      </div>
                    )}
                    {plane.nextAnnual && (
                      <div style={{ marginBottom: '0.5rem', color: '#666' }}>
                        📋 Next Annual: {formatDateMmDdYyyy(plane.nextAnnual)}
                      </div>
                    )}
                    {plane.nextHundredHour && (
                      <div style={{ marginBottom: '0.5rem', color: '#666' }}>
                        ⏱️ Next 100-Hour: {plane.nextHundredHour} hours
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default MobileAircraft;